import script from "./Nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav.vue?vue&type=script&lang=ts&setup=true"

import "./Nav.vue?vue&type=style&index=0&id=129197d6&lang=scss"

const __exports__ = script;

export default __exports__